module.exports = __webpack_public_path__ + "static/img/8.116bb89.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/3/1/zh/8.png
// module id = hRwJ
// module chunks = 0